import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  text: {
    color: theme.palette.secondary.main,
    // marginBottom: "5px"
    whiteSpace: "pre-line",
  },
}));
